import { render, staticRenderFns } from "./BulkNewBatchDialog.vue?vue&type=template&id=2a53fcdf"
import script from "./BulkNewBatchDialog.vue?vue&type=script&lang=js"
export * from "./BulkNewBatchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports